// chakra imports
import { Box, Flex, Stack } from '@chakra-ui/react';
//   Custom components
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import SidebarCard from 'components/sidebar/components/SidebarCard';
import React from 'react';

// FUNCTIONS

function SidebarContent(props) {
  const { routes, onNavigate } = props;
  return (
    <Flex direction="column" height="100%" pt="25px" px="0px">
      <Brand />
      <Stack direction="column" mb="auto" mt="8px">
        <Box px="0px">
          <Links routes={routes} onNavigate={onNavigate} />
        </Box>
      </Stack>

      <Box mt="60px" mb="40px" px="0px">
        <SidebarCard />
      </Box>
    </Flex>
  );
}

export default SidebarContent;
